"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldWidget = void 0;
var tslib_1 = require("tslib");
var tableau_ui_1 = require("@tableau/tableau-ui");
var React = require("react");
var TypeStyle = require("typestyle");
var Localize_1 = require("../../../gen-src/Localize");
var Declarative_1 = require("../../utils/Declarative");
var DomUtil_1 = require("../../utils/DomUtil");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
/** A drop-in replacement for an INPUT element with standard styling, accessible label and validation messages, and focus indication. */
exports.TextFieldWidget = React.forwardRef(function (props, ref) {
    var className = props.className, onBlur = props.onBlur, onChange = props.onChange, selectOnFocus = props.selectOnFocus, testId = props.testId, fieldProps = tslib_1.__rest(props, ["className", "onBlur", "onChange", "selectOnFocus", "testId"]);
    var isComposing = React.useRef(false);
    var StyleName = TypeStyle.style({
        $nest: {
            '&.required label::after': {
                content: "\"" + Localize_1.Messages.required() + "\"",
                marginLeft: 4,
            },
            '&.required.invalid label::after': {
                color: '#c93a47',
                fontWeight: 'bold',
            },
            '&.optional label::after': {
                content: "\"" + Localize_1.Messages.optional() + "\"",
                marginLeft: 4,
            }
        }
    });
    return React.createElement(tableau_ui_1.TextField, tslib_1.__assign({}, ReactHelpers_1.EventUtilsOptOut, { "data-tb-test-id": Declarative_1.makeTestId(testId, 'TextInput') }, fieldProps, { className: TypeStyle.classes(className, StyleName, {
            required: fieldProps.required === true,
            optional: fieldProps.required === false,
        }), onBlur: onBlur && (function (e) {
            e.relatedTarget = DomUtil_1.findBlurRelatedTarget(e); // polyfill for IE11
            onBlur(e);
        }), onChange: onChange && (function (e) { return onChange(tslib_1.__assign(tslib_1.__assign({}, e), { isComposing: isComposing.current })); }), onCompositionEnd: ReactHelpers_1.mergeEventHandlers(function (e) {
            isComposing.current = false;
            onChange === null || onChange === void 0 ? void 0 : onChange(tslib_1.__assign(tslib_1.__assign({}, e), { isComposing: false }));
        }, props.onCompositionEnd), onCompositionStart: ReactHelpers_1.mergeEventHandlers(function () { return isComposing.current = true; }, props.onCompositionStart), onFocus: function (e) {
            var _a;
            if (DomUtil_1.shouldIgnoreFocusEvent(e)) {
                return;
            }
            if (selectOnFocus) {
                DomUtil_1.selectInputText(e.target);
            }
            (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
        }, ref: ref }));
});
exports.TextFieldWidget.displayName = 'TextFieldWidget';
exports.TextFieldWidget.defaultProps = { kind: 'outline' };
//# sourceMappingURL=TextFieldWidget.js.map